import React, { FC, useContext } from 'react';
import { FocusContext } from '../../index.contexts';
import SearchSecondaryBar from './searchSecondaryBar';

const SearchSecondaryBarLazy: FC<{ isPublishUserSelection: boolean; isSearchPage?: boolean; isADFPage?: boolean }> = ({
  isPublishUserSelection = false,
  isSearchPage = false,
  isADFPage = false,
}) => {
  const { isUserInteractWithComp } = useContext(FocusContext);

  return (
    <SearchSecondaryBar
      isPublishUserSelection={isPublishUserSelection}
      isUserInteractWithComp={isUserInteractWithComp}
      isSearchPage={isSearchPage}
      isADFPage={isADFPage}
    />
  );
};

export default SearchSecondaryBarLazy;
